import React, { useState, useEffect } from "react";
import Header from "../../components/Headers/Header";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Card,
  CardBody,
  Button,
  Row,
  Col,
  Input,
  Badge,
  Spinner,
  Modal,
  ModalBody,
} from "reactstrap";
import { getPlayerIssues } from "store/actions/generalActions";
import { getUserIssues } from "store/actions/generalActions";
import moment from "moment";
import { deleteIssue } from "store/actions/generalActions";
import { updateIssue } from "store/actions/generalActions";
import { getIssuesStats } from "store/actions/generalActions";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

function Complaint() {
  let dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(1);
  const [searchVal, setSearchVal] = useState("");
  const [loader, setLoader] = useState({
    data: false,
    loadMore: false,
    totalIssue: false,
    btn: false,
    filter: false,
    clearFilter: false,
  });
  let {
    hasMorePlayerIssues,
    lastDocumentPlayerIssues,
    hasMorUserIssues,
    lastDocumentUserIssues,
    playerIssues,
    userIssues,
    issues,
  } = useSelector((state) => state.general);

  const infoPoints = [
    "In the Issues module, the admin reviews problems reported by fans and athletes. Summary cards at the top display the total number of issues raised, and the admin can choose to accept or reject each request.",
  ];
  const subPoints = [];
  const infoTitle = "Issues Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
      totalIssue: true,
    }));
    dispatch(
      getPlayerIssues("", "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getIssuesStats(() => {
        setLoader((prev) => ({
          ...prev,
          totalIssue: false,
        }));
      })
    );
  }, []);
  const handleGetPlayerIssues = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getPlayerIssues("", "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const handleGetUsersIssues = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getUserIssues("", "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const loadMoreUser = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getUserIssues("", lastDocumentUserIssues, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const loadMorePlayer = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getPlayerIssues("", lastDocumentPlayerIssues, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const [deleteModal, setDeleteModal] = useState(false);
  const [issueId, setIssueId] = useState("");
  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const applyFilter = () => {
    setLoader((prev) => ({
      ...prev,
      filter: true,
    }));
    if (activeTab == 1) {
      dispatch(
        getPlayerIssues(Number(searchVal), "", () => {
          setLoader((prev) => ({
            ...prev,
            filter: false,
          }));
        })
      );
    } else {
      dispatch(
        getUserIssues(Number(searchVal), "", () => {
          setLoader((prev) => ({
            ...prev,
            filter: false,
          }));
        })
      );
    }
  };
  const clearFilter = () => {
    setLoader((prev) => ({
      ...prev,
      clearFilter: true,
    }));
    if (activeTab == 1) {
      dispatch(
        getPlayerIssues("", "", () => {
          setSearchVal("");
          setLoader((prev) => ({
            ...prev,
            clearFilter: false,
          }));
        })
      );
    } else {
      dispatch(
        getUserIssues("", "", () => {
          setSearchVal("");
          setLoader((prev) => ({
            ...prev,
            clearFilter: false,
          }));
        })
      );
    }
  };

  // Define table columns and key mapping
  const columns = ["Name", "Date", "Issue ID", "Message", "Status"];
  const keyMap = {
    Name: "name",
    Date: "formattedDate",
    "Issue ID": "issue_id",
    Message: "message",
    Status: "displayStatus",
  };

  const processData = (data) => {
    return data.map((d) => {
      let statusColor =
        d.status === "submitted"
          ? "danger"
          : d.status === "in progress"
          ? "primary"
          : "success";

      return {
        ...d,
        formattedDate: moment.unix(d.created_at.seconds).format("DD MMM YYYY"),
        displayStatus: (
          <Badge color={statusColor} className={`bg-${statusColor} text-white`}>
            {d.status === "submitted" ? "Pending" : d.status}
          </Badge>
        ),
        message: (
          <div
            title={d.message}
            className="custom-table-text text-ellipsis complaint-message-max-width"
          >
            {d.message}
          </div>
        ),
      };
    });
  };

  const renderActions = (row) => (
    <>
      <Button
        disabled={row.status === "resolved"}
        size="sm"
        color="primary"
        onClick={() => {
          if (row.status === "submitted") {
            dispatch(updateIssue(row.id, "in progress"));
          } else if (row.status === "in progress") {
            dispatch(updateIssue(row.id, "resolved"));
          }
        }}
      >
        Change Status
      </Button>
      <Button
        size="sm"
        color="danger"
        onClick={() => {
          toggleDeleteModal();
          setIssueId(row.id);
        }}
      >
        Delete
      </Button>
    </>
  );
  return (
    <>
      <Header />
      <Container fluid>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Row className="no-gutters justify-content-center">
          <Col lg={4} md={6} sm={6} xs={12} align="center">
            <div
              onClick={() => {
                setActiveTab(1);
                handleGetPlayerIssues();
                setSearchVal("");
              }}
              className={`complaint-card ${
                activeTab == 1 ? "complaint-card-active" : ""
              }`}
            >
              <p className="complaint-card-number mb-1">
                {loader.totalIssue ? (
                  <Spinner size="sm" />
                ) : (
                  issues?.athlete_issues
                )}
              </p>
              <p className="complaint-card-text">Athletes Issues</p>
            </div>
          </Col>
          <Col
            lg={4}
            md={6}
            sm={6}
            xs={12}
            align="center"
            className="mt-3 mt-sm-0"
          >
            <div
              onClick={() => {
                setActiveTab(2);
                handleGetUsersIssues();
                setSearchVal("");
              }}
              className={`complaint-card ${
                activeTab == 2 ? "complaint-card-active" : ""
              }`}
            >
              <p className="complaint-card-number mb-1">
                {loader.totalIssue ? <Spinner size="sm" /> : issues?.fan_issues}
              </p>
              <p className="complaint-card-text">Fans Issues</p>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card className="filter-card">
              <CardBody className="custom-card-body">
                <Row className="mt-1">
                  <Col xs={12} sm={6} md={4}>
                    <Input
                      value={searchVal}
                      onChange={(e) => setSearchVal(e.target.value)}
                      type="number"
                      className="mt-2 mt-sm-0 custom-filter-input"
                      placeholder="Search By Issue ID"
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    md={8}
                    className="d-flex justify-content-center justify-content-sm-end align-items-center mt-2 mt-sm-0"
                  >
                    <Button
                      size="sm"
                      color="danger"
                      onClick={clearFilter}
                      disabled={loader.clearFilter}
                      className="me-sm-2"
                    >
                      {loader.clearFilter ? <Spinner size="sm" /> : "Clear"}
                    </Button>
                    <Button
                      size="sm"
                      color="primary"
                      onClick={applyFilter}
                      disabled={loader.filter}
                    >
                      {loader.filter ? <Spinner size="sm" /> : "Apply"}
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {activeTab == 1 ? (
          loader.data ? (
            <div className="text-center my-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <Card className="p-2 my-4">
                <TableComponent
                  columns={columns}
                  data={processData(playerIssues)}
                  keyMap={keyMap}
                  renderActions={renderActions}
                />
                {playerIssues.length > 4 && (
                  <div className="text-center py-4">
                    <Button
                      color="primary"
                      onClick={loadMorePlayer}
                      disabled={loader.loadMore || !hasMorePlayerIssues}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : "Load More"}{" "}
                    </Button>
                  </div>
                )}
              </Card>
            </>
          )
        ) : loader.data ? (
          <div className="text-center my-4">
            <Spinner color="primary" size="sm" />
          </div>
        ) : (
          <>
            <Card className="p-2 my-4">
              <TableComponent
                columns={columns}
                data={processData(userIssues)}
                keyMap={keyMap}
                renderActions={renderActions}
              />
              {userIssues?.length > 4 && (
                <div className="text-center py-4">
                  <Button
                    color="primary"
                    onClick={loadMoreUser}
                    disabled={loader.loadMore || !hasMorUserIssues}
                  >
                    {loader.loadMore ? <Spinner size="sm" /> : "Load More"}{" "}
                  </Button>
                </div>
              )}
            </Card>
          </>
        )}
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={deleteModal} centered toggle={toggleDeleteModal}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to Delete.
            </span>
            <br />
            <br />
            <br />
            <Button
              color="primary"
              onClick={() => {
                setLoader((prev) => ({
                  ...prev,
                  btn: true,
                }));
                dispatch(
                  deleteIssue(issueId, () => {
                    toggleDeleteModal();
                    setLoader((prev) => ({
                      ...prev,
                      btn: false,
                    }));
                  })
                );
              }}
            >
              {loader.btn ? <Spinner size="sm" /> : "Yes"}
            </Button>
            <Button color="danger" onClick={toggleDeleteModal}>
              NO
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Complaint;
